module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeMins),
      expression: "startTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "01",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeSecs),
      expression: "startTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "21",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeSecs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "time-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeMins),
      expression: "endTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "09",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeSecs),
      expression: "endTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "57",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeSecs = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "select mb-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dimension),
      expression: "dimension"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dimension = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dimensions), function(dim) {
    return _c('option', [_vm._v(_vm._s(dim))])
  }))]), _vm._v(" "), _c('MultiAnswer', {
    attrs: {
      "ta1": _vm.data.ta1,
      "ta2": _vm.data.ta2,
      "ta3": _vm.data.ta3
    },
    on: {
      "update:ta1": function($event) {
        _vm.$set(_vm.data, "ta1", $event)
      },
      "update:ta2": function($event) {
        _vm.$set(_vm.data, "ta2", $event)
      },
      "update:ta3": function($event) {
        _vm.$set(_vm.data, "ta3", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    staticClass: "button is-info mb-2",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger mb-2 mr-2",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1608c5f6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateArtFormComment.vue
// module id = 987
// module chunks = 0